import { render, staticRenderFns } from "./Topbaner.vue?vue&type=template&id=0647528f&"
import script from "./Topbaner.vue?vue&type=script&lang=js&"
export * from "./Topbaner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports